ko.bindingHandlers["hasOverflow"] =
   "update": (element, valueAccessor) ->
      trigger = ko.unwrap(valueAccessor().trigger)
      hasOverflow = valueAccessor().overflowing
      # Give changes time to render.
      setTimeout ->
         hasOverflow(element.offsetHeight < element.scrollHeight)